import api from '../../services/api';
import moment from 'moment';
import * as type from '../types';
import { state as globalState } from '../store';
export default {
    namespaced: true,
    state: {
        headers: [
			{ text: 'Date Uploaded', value: 'dateUploaded', sortable: true},
			{ text: 'Batch ID', value: 'batchId', sortable: true},
			{ text: 'Brand', value: 'brandname', sortable: true},
            { text: 'Total Count', value: 'totalCount', sortable: true},
            { text: 'User', value: 'currentUser', sortable: true},
			{ text: 'Status', value: 'status', sortable: true, width: '200', formatter: row => `${row.status === 1 ?  'Ongoing' : 'Complete'}`},
			{ text: 'Actions', width: '150', align: 'center', alignHeader: 'center' }
        ],
        items: [],
        brands: [],
        users: [],
        status: []
    },
    getters: {
        headers: state => state.headers,
        items: state => state.items,
        brands: state => state.brands,
        users: state => state.users,
        status: state => state.status
    },
    mutations: {
        [type.GET_UPLOAD_HISTORY]: (state, payload) => state.items = payload,
        [type.GET_BRAND_RECORDS]: (state, payload) => state.brands = payload,
        [type.GET_USER_RECORDS]: (state, payload) => state.users = payload,
        [type.GET_STATUS_RECORDS]: (state, payload) => state.status = payload
    },
    actions: {
        [type.GET_BRAND_RECORDS]: async ({commit}) => {
            commit(type.GET_BRAND_RECORDS, []);
            try {
                let response = await api.get(`/file/stored-list`);
                let result = response.data.map(e => e.brand_name);
                commit(type.GET_BRAND_RECORDS, [...new Set(result)]);
            } catch (error) {
                commit(type.GET_BRAND_RECORDS, []);
            }
        },
        [type.GET_USER_RECORDS]: async ({commit}) => {
            commit(type.GET_USER_RECORDS, []);
            try {
                let response = await api.get(`/file/stored-list`);
                let result = response.data.map(e => e.curr_user);
                commit(type.GET_USER_RECORDS, [...new Set(result)]);
            } catch (error) {
                commit(type.GET_USER_RECORDS, []);
            }
        },
        [type.GET_STATUS_RECORDS]: async ({commit}) => {
            commit(type.GET_STATUS_RECORDS, []);
            try {
                let response = await api.get(`/file/stored-list`);
                let result = response.data.map(e => e.status)

                let modifiedResult = [...new Set(result)].map(e => {
                    let statusText = e == 2 ? 'Added to Records' : 'Parsed'
                    return {
                        value: e,
                        text: statusText
                    }
                });
                
                commit(type.GET_STATUS_RECORDS, modifiedResult);
            } catch (error) {
                commit(type.GET_STATUS_RECORDS, []);
            }
        },
        [type.GET_UPLOAD_HISTORY]: async ({commit}, payload) => {
            commit(`global/${type.SET_LOADING}`, null, { root: true });
            commit(type.GET_UPLOAD_HISTORY, []);

            const { startDate, endDate, brandName, currentUser, status, searchFilter } = payload;
            let query = '';
            if(startDate && endDate){ query = query ? `${query}&startDate=${startDate}&endDate=${endDate}` : `startDate=${startDate}&endDate=${endDate}` }
            if(brandName){ query = query ? `${query}&brandName=${brandName}` : `brandName=${brandName}` }
            if(currentUser){ query = query ? `${query}&currentUser=${currentUser}` : `currentUser=${currentUser}` }
            if(status){ query = query ? `${query}&status=${status}` : `status=${status}` }
            if(searchFilter){ query = query ? `${query}&searchFilter=${searchFilter}` : `searchFilter=${searchFilter}` }

            try {
                let response = await api.get(`/file/stored-list?${query}`);
                if (response.status === 200) {
					let result = response.data.map(e => {
						let dateUploaded = moment(e.date_uploaded).utcOffset('+08:00').format('MM/DD/YYYY');
						
						return {
							id: e.id,
							batchId: e.batch_id,
							currentUser: e.curr_user,
							brandname: e.brand_name,
							filename: e.file_name,
							fileLink: e.file_link,
                            status: e.status,
                            totalCount: e.total_count,
							dateUploaded
						};
                    });
                    commit(type.GET_UPLOAD_HISTORY, result)
				}
            } catch (error) {
                commit(type.GET_INVOICE_RECORDS, []);
                commit(`global/${type.SET_MESSAGE}`, { type: 'error', message: error.data.err.msg }, { root: true });
            }finally{
                commit(`global/${type.REMOVE_LOADING}`, null, { root: true })
            }
        },
        [type.VIEW_PARSED_RESULT]: async ({commit}, payload) => {
            try {
				globalState.parsedResults = []
				let response = await api.post('/file/reader', JSON.stringify({
					typeOfRequest :"readFile",
					fileName: payload.filename
				}))
				if(response.status === 200){
					let invoiceType = payload.invoiceType !== null && payload.invoiceType
					let insertToDb = [
						{ id: payload.id },
						{ file_name: payload.filename },
						{ file_link: payload.fileLink },
					];
					let index = 0;
					let invoiceInformation = response.data.invoiceInformation[0];
					let invoiceItem = response.data.invoiceItem.map(e => {
						return {
							...e,
							id: index++
						}
					})
					globalState.parsedResults = {
						invoiceType,
						insertToDb,
						invoiceInformation,
						invoiceItem
                    }
                    commit(`global/${type.SET_ROUTE}`, `/upload-result?batchId=${payload.batchId}&brandname=${payload.brandname}&timestamp=${Date.now()}`, { root: true })
				}
			} catch (error) {
                commit(`global/${type.SET_MESSAGE}`, { type: 'error', message: error }, { root: true });
			}
        }
    }
}